import { atom } from "recoil";

export interface RefundQnA {
  questionId: number;
  answerId: number;
  answer: string;
}

export const refundQnAListState = atom<RefundQnA[]>({
  key: "refundQnAListState",
  default: [],
});
